import { on } from 'delegated-events'

const fn = {
  init: () => {
    fn.bindEvents()

    document.querySelectorAll('[data-tag-list] .tag-item').forEach((x) => {
      if (x.getAttribute('aria-selected') === 'true') {
        const tagList = x.closest('[data-tag-list]')
        const tag = x.dataset.tag

        if (tagList.dataset.tagList !== 'artist-projects-grid') {
          fn.handleTag(tagList, tag)
        }
      }
    })

    on('handletag', 'html', (e) => {
      fn.handleTag(e.detail.tagList, e.detail.tag)
    })
  },
  bindEvents: () => {
    on('click', '[data-tag-list] .tag-item', (e) => {
      e.preventDefault()

      const tagList = e.target.closest('[data-tag-list]')
      const tag = e.target.dataset.tag

      if (e.target.getAttribute('aria-selected') === 'true') {
        fn.clearTag(tagList)
        e.target.removeAttribute('aria-selected')
      } else {
        tagList.querySelectorAll('.tag-item').forEach((x) => x.removeAttribute('aria-selected'))
        e.target.setAttribute('aria-selected', true)
        fn.handleTag(tagList, tag)
      }
    })
  },
  handleTag: (tagList, tag) => {
    const tagArea = document.getElementById(tagList.dataset.tagList)

    tagArea.querySelectorAll('[data-tags]').forEach((x) => {
      x.classList.add('is-hidden')

      const tags = JSON.parse(x.dataset.tags)

      if (tags.includes(tag)) {
        x.classList.remove('is-hidden')
      }
    })

    const url = new URL(window.location)
    url.searchParams.set('tag', tag)
    window.history.replaceState({}, '', url)

    const rect = tagArea.getBoundingClientRect()
    const isVisible = rect.top >= 0 && rect.top <= window.innerHeight

    if (!isVisible) {
      tagArea.scrollIntoView({
        behavior: 'smooth',
      })
    }
  },
  clearTag: (tagList) => {
    const tagArea = document.getElementById(tagList.dataset.tagList)

    tagArea.querySelectorAll('[data-tags]').forEach((x) => {
      x.classList.remove('is-hidden')
    })

    const url = new URL(window.location)
    url.searchParams.delete('tag')
    window.history.replaceState({}, '', url)
  },
}

export default {
  can: () => true,
  run: fn.init,
}
